/* eslint-disable no-case-declarations */
import {
  FORUM_LIST_SUCCESS,
  FORUM_LIST_PUBLISH_SUCCESS,
  FORUM_LIST_COLLECT_SUCCESS,
  FORUM_ACTION_REMOVE_SUCCESS,
  FORUM_ACTION_SET_SUCCESS,
  FORUM_ASS_WORD_SUCCESS,
  FORUM_UPLOAD_PARAMS_SUCCESS,
  FORUM_INFO_SUCCESS,
  FORUM_CONTENT_SUCCESS,
  FORUM_SUBMIT_SUCCESS,
  FORUM_DELETE_SUCCESS,
  FORUM_COMMENT_ADD_SUCCESS,
  FORUM_COMMENT_ZAN_SUCCESS, // 点赞成功
  FORUM_COMMENT_REVIEW_SUCCESS,
  FORUM_COMMENT_GRADE_SUCCESS,
  FORUM_COMMENT_LIST_SUCCESS, // 帖子评论列表
  FORUM_COMMENT_LOADING, // 评论加载状态
  FORUM_COMMENT_REVIEW_SHOW, // 展示评论回复弹框
  FORUM_COMMENT_LIST_UPDATE, // 修改评论列表的数据
  FORUM_COMMENT_LIST_COLLAPSE, // 更改评论列表帖子的折叠状态
} from '../constants/forum';

const initState = {
  forumList: {},
  forumListPub: {},
  forumListCol: {},
  forumLenovoSoft: {},
  forumDelete: {},
  forumDetail: {},
  forumDetailMore: {},
  forumAddComment: {},
  forumAddReview: {},
  forumCommentList: null,
  forumReviewShow: null,
};

const forum = (state = initState, action = {}) => {
  switch (action.type) {
    case FORUM_LIST_SUCCESS:
      return { ...state, forumList: action.payload };
    case FORUM_LIST_PUBLISH_SUCCESS:
      return { ...state, forumListPub: action.payload };
    case FORUM_LIST_COLLECT_SUCCESS:
      return { ...state, forumListCol: action.payload };
    case FORUM_ASS_WORD_SUCCESS:
      return { ...state, forumLenovoSoft: action.payload };
    case FORUM_DELETE_SUCCESS:
      let newForumListPub = [];
      if (
        state.forumListPub &&
        state.forumListPub.count > 0 &&
        state.forumListPub.forumContentList.length > 0
      ) {
        newForumListPub = state.forumListPub.forumContentList.filter(item => {
          return item.id !== action.payload.id;
        });
      }
      return {
        ...state,
        forumDelete: action.payload,
        forumListPub: {
          ...state.forumListPub,
          forumContentList: newForumListPub,
          count: --state.forumListPub.count,
        },
      };
    case FORUM_INFO_SUCCESS:
      return { ...state, forumDetail: action.payload };
    case FORUM_CONTENT_SUCCESS:
      return { ...state, forumDetailMore: action.payload };
    case FORUM_COMMENT_ADD_SUCCESS:
      // 避免重复提交
      if (action.payload.loading || action.payload.status !== 0) {
        return { ...state, forumAddComment: action.payload };
      }
      let ocommentList = [...((state.forumCommentList && state.forumCommentList.dataList) || [])];
      ocommentList = [
        {
          ...action.payload.data,
          comment: action.payload.data.model,
        },
        ...ocommentList,
      ];
      return {
        ...state,
        forumAddComment: action.payload,
        forumCommentList: {
          ...(state.forumCommentList || {}),
          totalCount: (state.forumCommentList.totalCount || 0) + 1,
          dataList: ocommentList,
        },
      };
    case FORUM_COMMENT_REVIEW_SUCCESS:
      return { ...state, forumAddReview: action.payload };
    case FORUM_COMMENT_LIST_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const { data = {}, refresh } = action.payload;
      const { hotdatalist = [], dataList = [], totalCount = 0 } = data;
      const refreshList = [...(data.dataList || [])];
      const commentList = refresh
        ? {
            ...data,
            dataList: refreshList,
            totalCount: +totalCount,
            hotdatalist: hotdatalist.map(item => ({ ...item, hot: true })),
          }
        : {
            ...state.forumCommentList,
            dataList: [...state.forumCommentList.dataList, ...dataList],
            // hotdatalist: hotdatalist.map(item => ({ ...item, hot: true })),
          };
      return { ...state, forumCommentList: commentList };
    case FORUM_COMMENT_LOADING:
      return {
        ...state,
        forumCommentList: {
          ...state.forumCommentList,
          loading: action.payload,
        },
      };
    case FORUM_COMMENT_REVIEW_SHOW:
      return { ...state, forumReviewShow: action.payload };
    case FORUM_COMMENT_LIST_UPDATE:
      const list = state.forumCommentList.dataList;
      const hotlist = state.forumCommentList.hotdatalist || [];
      try {
        if (action.payload.model) {
          const index = list.findIndex(
            item => item.comment.id === action.payload.model.originalCommentId,
          );
          // 热门评论
          const hotIndex = hotlist.findIndex(
            item => item.comment.id === action.payload.model.originalCommentId,
          );
          if (index > -1) {
            if (action.payload.model.originalCommentId === action.payload.model.parentId) {
              if (list[index].replys) {
                list[index].replys.unshift(action.payload.model);
              } else {
                list[index].replys = [action.payload.model];
              }
            } else {
              const childIndex =
                list[index].replys &&
                list[index].replys.findIndex(item => item.id === action.payload.model.parentId);
              if (childIndex > -1) {
                list[index].replys.splice(childIndex + 1, 0, action.payload.model);
              }
            }
          }
          // 热门评论
          if (hotIndex > -1) {
            if (action.payload.model.originalCommentId === action.payload.model.parentId) {
              if (hotlist[hotIndex].replys) {
                hotlist[hotIndex].replys.unshift(action.payload.model);
              } else {
                hotlist[hotIndex].replys = [action.payload.model];
              }
            } else {
              const hotchildIndex =
                hotlist[hotIndex].replys &&
                hotlist[hotIndex].replys.findIndex(
                  item => item.id === action.payload.model.parentId,
                );
              if (hotchildIndex > -1) {
                hotlist[hotIndex].replys.splice(hotchildIndex + 1, 0, action.payload.model);
              }
            }
          }
        }
      } catch (err) {}
      return {
        ...state,
        forumCommentList: {
          ...state.forumCommentList,
          dataList: list,
        },
        forumAddComment: {},
        forumReviewShow: null,
      };
    case FORUM_COMMENT_ZAN_SUCCESS:
      const datalist = state.forumCommentList.dataList;
      const dataHotlist = state.forumCommentList.hotdatalist || [];
      if (action.payload.data && action.payload.data.originalCommentId) {
        const index = datalist.findIndex(
          item => item.comment.id === action.payload.data.originalCommentId,
        );
        const hotIndex = dataHotlist.findIndex(
          item => item.comment.id === action.payload.data.originalCommentId,
        );
        if (index > -1) {
          datalist[index] = {
            ...datalist[index],
            hasZan: 1,
            zanCounter: +(datalist[index].zanCounter || 0) + 1,
          };
        }
        if (hotIndex > -1) {
          dataHotlist[hotIndex] = {
            ...dataHotlist[hotIndex],
            hasZan: 1,
            zanCounter: +(dataHotlist[hotIndex].zanCounter || 0) + 1,
          };
        }
      }
      return {
        ...state,
        forumCommentList: {
          ...state.forumCommentList,
          dataList: datalist,
          hotdatalist: dataHotlist,
        },
      };
    case FORUM_ACTION_SET_SUCCESS:
      const type = action.payload.actionType;
      const forumDetail = { ...state.forumDetail };
      if (type === 1) {
        forumDetail.hasCollect = 1;
        forumDetail.collectCount = +(forumDetail.collectCount || 0) + 1;
      }
      if (type === 2) {
        forumDetail.hasZan = 1;
        forumDetail.zanCount = +(forumDetail.zanCount || 0) + 1;
      }
      return {
        ...state,
        forumDetail,
      };

    case FORUM_ACTION_REMOVE_SUCCESS:
      const types = action.payload.actionType;
      const forumDetails = { ...state.forumDetail };
      const forumListCol = { ...state.forumListCol };
      let newForumListCol = [];

      if (types === 1) {
        forumDetails.hasCollect = 0;
        forumDetails.collectCount =
          (+forumDetails.collectCount > 1 ? forumDetails.collectCount : 1) - 1;
        // 删除收藏列表中的数据
        if (
          forumListCol &&
          forumListCol.forumContentList &&
          forumListCol.forumContentList.length > 0
        ) {
          newForumListCol = forumListCol.forumContentList.filter(item => {
            return item.id !== action.payload.targetId;
          });
        }
      }
      if (types === 2) {
        forumDetails.hasZan = 0;
        forumDetails.zanCount = (+forumDetails.zanCount > 1 ? forumDetails.zanCount : 1) - 1;
      }
      return {
        ...state,
        forumDetail: forumDetails,
        forumListCol: {
          ...state.forumListCol,
          count: --forumListCol.count,
          forumContentList: newForumListCol,
        },
      };
    case FORUM_COMMENT_LIST_COLLAPSE:
      const commentLists = state.forumCommentList.dataList || [];
      const hotList = state.forumCommentList.hotdatalist || [];
      if (action.payload.hot) {
        hotList[action.payload.index].open = true;
      } else {
        commentLists[action.payload.index].open = true;
      }
      return {
        ...state,
        forumCommentList: {
          ...state.forumCommentList,
          dataList: commentLists,
          hotdatalist: hotList,
        },
      };
    default:
      return state;
  }
};

export default forum;
